import React, { CSSProperties } from 'react'
import { twMerge } from 'tailwind-merge'

import IconFacebook from '../images/svg/icon-facebook.svg'
import IconInstagram from '../images/svg/icon-instagram.svg'
import IconLinkedIn from '../images/svg/icon-linkedin.svg'
import IconYouTube from '../images/svg/icon-youtube.svg'

export interface ISocialNetwork {
  socialNetworkType: string | null
  profileLink: string | null
}

interface SocialNetworksProps {
  networks: readonly (ISocialNetwork | null)[]
  iconColor?: string
  className?: string
}

const icons: { [key: string]: (color: any) => JSX.Element } = {
  facebook: (color: any) => <IconFacebook style={{ color }} />,
  instagram: (color: any) => <IconInstagram style={{ color }} />,
  linkedin: (color: any) => <IconLinkedIn style={{ color }} />,
  youtube: (color: any) => <IconYouTube style={{ color }} />,
}

export const SocialNetworks = ({
  networks,
  iconColor = '#2F2B5E',
  className = '',
}: SocialNetworksProps) => {
  const _className = twMerge('flex justify-center gap-2', className)

  return (
    <ul className={_className}>
      {networks &&
        networks.length &&
        networks.map((network) => {
          const icon = icons[network!.socialNetworkType!]

          return (
            <li key={network!.socialNetworkType!}>
              <a
                className="inline-block transition hover:-translate-y-1"
                href={network!.profileLink!}
                target="_blank"
              >
                {icon(iconColor)}
              </a>
            </li>
          )
        })}
    </ul>
  )
}
